<template>
  <div>
    <drawer :app="app" />

    <v-container class="mt-1">
      <v-card raised>
        <v-card-title v-if="id != null">
          {{ id.FirstName }} {{ id.LastName }} - {{$t('labels.PersonalDetails')}}
        </v-card-title>

        <div style="margin: 1px 5px 5px 15px">
          <div class="px-3" v-if="id != null">
            <v-row>
              <v-col cols="12" md="3" v-if="id.PrimaryFlag == false">
                <p_dd
                  menu="ApplicantGroupType"
                  :label="$t('labels.ApplicantType')"
                  v-model="id.ApplicantGroupTypeDD"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="3">
                <p_dd
                  menu="Salutation"
                  v-model="id.SalutationDD"
                  :label="$t('labels.Salutation')"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field v-model="id.FirstName">
                  <template slot="label"
                    ><span v-html="$t('labels.FirstName')"
                  /></template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field v-model="id.LastName">
                  <template slot="label"
                    ><span v-html="$t('labels.LastName')"
                  /></template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <comdatey
                  :label="$t('labels.DOB')"
                  :min="date120Years"
                  :max="date18Years"
                  v-model="id.DOB"
                />
              </v-col>
              <v-col cols="12" md="6">
                <!-- <v-text-field v-model="id.Email">
                   <template slot="label"><span v-html="$t('labels.Email')" /></template>
                </v-text-field> -->
                <com_Email v-model="id.Email" />
              </v-col>

              <v-col cols="12" md="3">
                 <com_phone @DisableSave="HomeDisableSave" v-model="id.HomePhone" :label="$t('labels.HomePhoneNumber')" :masked="false" />
                <!-- <v-text-field
                  :label="$t('labels.HomePhoneNumber')"
                  v-model="id.HomePhone"
                  v-mask="'(###) ###-####'"
                /> -->
              </v-col>
              <v-col cols="12" md="3">
                 <com_phone @DisableSave="MobileDisableSave" v-model="id.Mobile" :label="$t('labels.MobilePhoneNumber')" :masked="true" />
                <!-- <v-text-field
                  :label="$t('labels.MobilePhoneNumber')"
                  :masked="true"
                  v-model="id.Mobile"
                  v-mask="'(###) ###-####'"
                /> -->
              </v-col>

              <v-col
                v-if="this.app.ReqSin == 1 && this.app.showSin == true"
                cols="12"
                md="3"
              >
                <v-text-field
                  :rules="[rules.validate]"
                  v-model="id.SIN"
                  v-mask="'### ### ###'"
                >
                  <template slot="label"
                    ><span v-html="$t('labels.SINR')"
                  /></template>
                </v-text-field>
              </v-col>
              <v-col
                v-else-if="this.app.ReqSin == 2 && this.app.showSin == true"
                cols="12"
                md="3"
              >
                <v-text-field
                  :rules="[rules.validate]"
                  v-model="id.SIN"
                  v-mask="'### ### ###'"
                >
                  <template slot="label"
                    ><span v-html="$t('labels.SIN')"
                  /></template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <p_dd
                  :label="$t('labels.MaritalStatus')"
                  menu="MaritalStatus"
                  v-model="id.MaritalStatusDD"
                />
              </v-col>
              <v-col cols="12" md="6" v-if="id.PrimaryFlag == false">
                <p_dd
                  menu="Relationship"
                  :label="$t('labels.RelationshipToPrimaryApplicant')"
                  v-model="id.RelationshipDD"
                />
              </v-col>

              <v-col cols="12" md="3" v-if="id.PrimaryFlag == true && app.FirstTimeBuyer == true">
                <v-switch
                  color="primary"
                  v-model="id.FirstTimeHomeBuyerFlag"
                  :label="$t('labels.FirstTimeHomeBuyer')"
                  :false-value="false"
                  :true-value="true"
                ></v-switch>
              </v-col>
            </v-row>
          </div>
          <v-card v-if="this.app.showType == true">
            <v-card-title  >          
              <span>Identification</span> <span v-if="this.app.ReqType == true" style="color:red;margin-left: 2px">*</span>
            </v-card-title>
            <div style="margin: 1px 5px 5px 15px">
              <div class="px-3" v-if="id != null">
                <v-row>
                  <v-col cols="12" v-if="id.IdentificationLst && id.IdentificationLst.length > 0">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">{{ $t("labels.NType") }}</th>
                            <th class="text-left">
                              {{ $t("labels.NCountry") }}
                            </th>
                            <th class="text-left">
                              {{ $t("labels.IdentificationNumber") }}
                            </th>
                            <th class="text-right" width="150">
                              <span> </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in id.IdentificationLst"
                            :key="item.IdentificationID"
                          >
                            <td>{{ item.strType }}</td>
                            <td>{{ item.Country }}</td>
                            <td>{{ item.IdentificationNumber }}</td>
                            <td class="text-right">
                              <v-btn
                                @click="edit(item.IdentificationID)"
                                text
                                small
                                color="primary"
                                ><v-icon small>fas fa-edit</v-icon></v-btn
                              >
                              <v-btn
                                @click="del(item.IdentificationID)"
                                text
                                small
                                color="red"
                                ><v-icon small>fas fa-trash-alt</v-icon></v-btn
                              >
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-card>
          <v-card-actions class="mb-5 mt-10">
             <v-btn v-if="((this.app.RequestReview == true && this.app.DisplayMortgage == true) || this.app.RequestReview == false)" @click="back" color="grey lighten-1">{{ $t("labels.Back") }}</v-btn>
            <v-spacer />           
            <v-btn v-if="this.app.showType == true" @click="add" color="primary"><v-icon x-small class="mr-2">fas fa-plus</v-icon>{{$t('labels.AddIdentification')}}</v-btn>
            <v-btn :disabled="this.MobileDisableSaveFlag == true || this.HomeDisableSaveFlag == true" @click="next" color="primary float-right">{{
              $t("labels.Next")
            }}</v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-container>

    <div class="loading" v-if="loadFlag">Loading&#8230;</div>
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline" >Identification</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <small  v-html="$t('labels.RequiredFieldsDesc')" />
            <v-row>
              <v-col cols="12" md="12">
                <p_dd
                  :label="$t('labels.TypeR')"
                  menu="IdentificationType"
                  v-model="IdentificationItem.Type"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="IdentificationItem.Country">
                  <template slot="label"
                    ><span v-html="CountryLabel()"
                  /></template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="IdentificationItem.IdentificationNumber">
                  <template slot="label"
                    ><span v-html="IdentificationLabel()"
                  /></template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
         <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogClose">{{$t('labels.Close')}}</v-btn>
          <v-btn color="blue darken-1" text @click="dialogSave">{{$t('labels.Save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import drawer from "@/pages/app/agent/user/app/drawer";
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import model from "@/shared/dataModels/app";
import p_dd from "@/shared/components/ddSelect";
import comdatey from "@/shared/components/datePickerY";
import com_Email from "@/shared/components/email";
import com_phone from "@/shared/components/phone";
export default {
  components: { comdatey, drawer, p_dd, com_Email,com_phone },
  data() {
    return {
      MobileDisableSaveFlag: false,
      HomeDisableSaveFlag: false,
      ReviewApplication: false,
      RequiredDesc: false,
      dialog: false,
      IdentificationItem: model.IdentificationItemModel(),
      rules: {
        validate: (value) => {
          if (value != "") {
            var val = value.replace(/\s/g, "");
            return this.checklength(val);
          } else {
            return true;
          }
        },
      },
      showSwitchToPrimaryFlag: true,
      loadFlag: false,
      app: model.appModel(),
      a: null,
      id: null,
      applicantID: this.$route.params.applicantid,
      mortgageApplicationID: this.$route.params.appid,
      siteID: this.$route.params.siteid,
      userID: null,
      drawerFlag: false,
    };
  },
  computed: {
    
    date18Years() {
      let n = new Date();
      n.setFullYear(n.getFullYear() - 17);
      return n.toISOString().substr(0, 10);
    },
    date120Years() {
      let n = new Date();
      n.setFullYear(n.getFullYear() - 120);
      return n.toISOString().substr(0, 10);
    },
  },
  methods: {
    HomeDisableSave(data){
      this.HomeDisableSaveFlag = data;
    },
     MobileDisableSave(data){
      this.MobileDisableSaveFlag = data;
    },
    
    back(){
       this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/start");
    },
    TypeLabel(){
      if((this.IdentificationItem.Type != null && this.IdentificationItem.Type != -1) || this.IdentificationItem.Country || this.IdentificationItem.IdentificationNumber){
         this.RequiredDesc = true;
        return this.$t('labels.TypeR');
      }else{
         this.RequiredDesc = false;
         return this.$t('labels.NType');
      }
    },
     CountryLabel(){
      if((this.IdentificationItem.Type != null && this.IdentificationItem.Type != -1) || this.IdentificationItem.Country || this.IdentificationItem.IdentificationNumber){
       this.RequiredDesc = true;
       return this.$t('labels.CountryR');
      }else{
        this.RequiredDesc = false;
         return this.$t('labels.Country');
      }
    },
     IdentificationLabel(){
      if((this.IdentificationItem.Type != null && this.IdentificationItem.Type != -1) || this.IdentificationItem.Country || this.IdentificationItem.IdentificationNumber){
        this.RequiredDesc = true;
        return this.$t('labels.IdentificationNumberR');
      }else{
        this.RequiredDesc = false;
         return this.$t('labels.IdentificationNumber');
      }
    },
    checklength: function (val) {
      var sin = val.replace(/\s/g, "");
      return this.validatesin(sin) || "Invalid SIN";
    },
     dialogClose() {
      this.dialog = false;
      this.IdentificationItem =model.IdentificationItemModel();

    },
    dialogValid(){
      if (
        this.IdentificationItem.Type == null || this.IdentificationItem.Type == -1         
      ) {
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("errors.IdentificationMissingType")
        );
        return false;
      }
      if (
        !this.IdentificationItem.Country        
      ) {
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("errors.IdentificationMissingCountry")
        );
        return false;
      }
      if (
        !this.IdentificationItem.IdentificationNumber        
      ) {
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("errors.IdentificationMissingIdentificationNumber")
        );
        return false;
      }
      return true;
    },
    dialogSave() {
     if (!this.dialogValid()) return;
      this.dialog = false;
      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
        Identification: this.IdentificationItem,
        ApplicantID: this.a.ApplicantID
      };
      dataSvc
        .getHttp()
        .post("/api/MTGAppUpsertIdentification", postData)
        .then(res => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200){
            this.id.IdentificationLst = res.data.Identifications;
          }
        });

      this.dialog = false;
    },
    edit(IdentificationID) {
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
        ApplicantID: this.a.ApplicantID,
        IdentificationID: IdentificationID,
      };
      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post("/api/MTGAPPLoadIdentification", postData)
        .then((res) => {
          this.loadFlag = false;
          this.IdentificationItem = res.data.Identification;
          this.dialog = true;
        });
    },
    del(IdentificationID) {
      this.$confirm(
        this.$t("labels.Warning"),
        this.$t("labels.ConfirmDeleteIdentification"),
        () => {
          if(this.id.IdentificationLst.length == 1 && this.app.ReqType == true){
            this.$alert(
            this.$t("labels.Warning"),
            this.$t("errors.DeleteIdentificationRequiredRecord")
          );
          return;
          }
          let postData = {
            SiteID: this.siteID,
            UserID: this.userID,
            MortgageApplicationID: this.mortgageApplicationID,
            ApplicantID: this.a.ApplicantID,
            IdentificationID: IdentificationID,
          };
          this.loadFlag = true;
          dataSvc
            .getHttp()
            .post("/api/MTGAPPDeleteIdentification", postData)
            .then((res) => {
              this.loadFlag = false;
              this.id.IdentificationLst = res.data.Identifications;
            });
        },
        () => {}
      );
    },

    validatesin(sin) {
      var check, even, tot;
      if (sin.length != 9) {
        return "Invalid SIN";
      }
      if (typeof sin === "number") {
        sin = sin.toString();
      }

      if (sin.length === 9) {
        // convert to an array & pop off the check digit
        sin = sin.split("");
        check = +sin.pop();

        even = sin
          // take the digits at the even indices
          .filter(function (_, i) {
            return i % 2;
          })
          // multiply them by two
          .map(function (n) {
            return n * 2;
          })
          // and split them into individual digits
          .join("")
          .split("");

        tot = sin
          // take the digits at the odd indices
          .filter(function (_, i) {
            return !(i % 2);
          })
          // concatenate them with the transformed numbers above
          .concat(even)
          // it's currently an array of strings; we want numbers
          .map(function (n) {
            return +n;
          })
          // and take the sum
          .reduce(function (acc, cur) {
            return acc + cur;
          });

        // compare the result against the check digit
        return check === (10 - (tot % 10)) % 10;
      } else throw "Invalid SIN";
    },
    setId(v) {
      setTimeout(() => {
        setTimeout(() => {
          this.id = v;
          this.id.SalutationDD = v.SalutationDD;
          this.id.ApplicantGroupTypeDD = v.ApplicantGroupTypeDD;
          this.id.RelationshipDD = -v.RelationshipDD;
          this.id.MartialStatusDD = v.MartialStatusDD;

          this.showSwitchToPrimaryFlag = !this.id.PrimaryFlag;
        }, 200);
      }, 200);
    },
    add(){
      this.IdentificationItem = model.IdentificationItemModel();
      this.dialog = true;
    },
    next() {
      if (!this.valid()) return;
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
        ApplicantID: this.applicantID,
        Identification: this.id,
        RequestReview: this.ReviewApplication
      };
      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post("/api/MTGAPPSaveIdentification", postData)
        .then((res) => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.$router.push(
              "/" +
                this.siteID +
                "/user/" +
                this.mortgageApplicationID +
                "/applicant/" +
                this.applicantID +
                "/address"
            );
          }
        });
    },
    valid() {
      if (this.id.ApplicantGroupTypeDD < 0) {
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("errors.IdentificationMissingApplicantGroupType")
        );
        return false;
      }
      if (!this.id.FirstName) {
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("errors.IdentificationMissingFirstName")
        );
        return false;
      }
      if (!this.id.LastName) {
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("errors.IdentificationMissingLastName")
        );
        return false;
      }
      if (!this.id.DOB) {
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("errors.IdentificationMissingDOB")
        );
        return false;
      }

      if (!this.id.Email) {
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("errors.RequiredEmailAddress")
        );
        return false;
      }
      if (!this.id.HomePhone && !this.id.Mobile) {
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("errors.IdentificationMissingPhone")
        );
        return false;
      }
      if (this.app.ReqSin == 1 && !this.id.SIN && this.app.showSin == true) {
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("errors.IdentificationSIN")
        );
        return false;
      }
      if (this.id.SIN) {
        var sin = this.id.SIN.replace(/\s/g, "");
        var res = this.validatesin(sin) || "Invalid SIN";
        if (res == "Invalid SIN") {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.InvalidSin"));
          return false;
        }
      }
      if (this.id.MaritalStatusDD == null) {
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("errors.IdentificationMissingMaritalStatus")
        );
        return false;
      }     
      if (!this.id.PrimaryFlag) {
        if (this.id.RelationshipDD < 0) {
          this.$alert(
            this.$t("labels.Warning"),
            this.$t("errors.IdentificationMissingRelationship")
          );
          return false;
        }
      }
    if(this.app.ReqType == true && this.app.showType == true){
      if(this.id.IdentificationLst.length == 0){
        this.$alert(
            this.$t("labels.Warning"),
            this.$t("errors.IdentificationRequiredRecord")
          );
          return false;
      }
    }
      return true;
    },
    setValue() {
      let tempDOB = this.id.strDOB;
      setTimeout(() => {
        this.id.DOB = "";
        setTimeout(() => {
          this.id.DOB = tempDOB;
        }, 200);
      }, 200);
    },

    loadPage() {
      if (this.appID != 0) {
        this.loadFlag = true;
        let postData = {
          SiteID: this.siteID,
          UserID: this.userID,
          MortgageApplicationID: this.mortgageApplicationID,
        };
        dataSvc
          .getHttp()
          .post("/api/MTGAPPLoad", postData)
          .then((res) => {
            this.loadFlag = false;
            if (res.data.ReturnStatus.ReturnCode == 200) {
              this.app = res.data;
              this.ReviewApplication = res.data.RequestReview;
              for (let i = 0; i < this.app.Applicants.length; i++) {
                if (this.app.Applicants[i].ApplicantID == this.applicantID) {
                  this.a = this.app.Applicants[i];
                  this.id = this.a.Identification;
                  this.showSwitchToPrimaryFlag = !this.id.PrimaryFlag;

                  this.setValue();
                }
              }
            }
            this.app.UserID = this.userID;
            this.app.SiteID = this.siteID;
          });
      } else {
        this.app.UserID = this.userID;
        this.app.SiteID = this.siteID;
      }
    },
  },
  created() {},
  mounted() {
    this.userID = localStorageSvc.getUser();
    if (this.userID != "") {
      this.loadPage();
    } else {
      this.$router.push("/" + this.siteID);
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.applicantID = to.params.applicantid;
    this.loadPage();
    next();
  },
  watch: {
    "id.RelationshipDD": {
      handler(n, o) {
        // if any other applicant is spouse / common law
        if (n == 1 || n == 0) {
          for (let i = 0; i < this.app.Applicants.length; i++) {
            if (this.app.Applicants[i].Identification.PrimaryFlag == true)
              continue;
            if (this.app.Applicants[i].ApplicantID != this.a.ApplicantID) {
              if (
                this.app.Applicants[i].Identification.RelationshipDD == 0 ||
                this.app.Applicants[i].Identification.RelationshipDD == 1
              ) {
                let tempName =
                  this.app.Applicants[i].Identification.FirstName +
                  " " +
                  this.app.Applicants[i].Identification.LastName;
                let msg = this.$t("errors.AlreadyHasSpouse");
                msg = msg.replace("{0}", tempName);
                this.$alert(this.$t("labels.Warning"), msg, () => {
                  this.id.RelationshipDD = o;
                });
                return;
              }
            }
          }
        }
        //  console.log( this.app.Applicants);
        //  console.log(n,o);
      },
      deep: false,
    },
  },
};
</script>

<style></style>
